export const TOKEN_NAME = "token";
export const FRONTEND_CONFIGURATION = "frontendConfiguration";
export const EXPAND_MOBILE_MENU = "expand_mobile_menu"

export const COMPANY = "company";

export const ORDERS_TAB = "ordersTab";
export const REPORT_TAB = "reportTab";
export const ASSISTENZA_TAB = "assistenzaTab";
export const EXTRA_SHARE_TAB = "extraShareTab";
export const SOGLIE_TAB = "soglieTab";

//Constants for master slave feature
export const AUTHORITY_TYPE = {
    MASTER: "MASTER",
    SLAVE: "SLAVE",
}
export const COMPANY_TYPE = {
    FATHER: "FATHER",
    SON: "SON"
}

//Constants for user types
export const OPERATOR = "operator";
export const CUSTOMER = "customer";

export const HEADER_CONTENT_DISPOSITION = 'content-disposition';
export const FILE_NAME = 'filename=';

